import { Validation } from "kit/helpers";
import DateService from "core/DateService";

import languageForms from "../language/language.forms";

import "core/ErrorLoggerService";
import "dayjs/locale/es";

DateService.setTimeZone("Europe/Madrid");
DateService.setLocale("es");
document.documentElement.classList.remove("no-js");

export default () => {
  Validation.setSuccessReturnValue(undefined);
  Validation.setLanguageObject(languageForms);
};
